import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconCheckboxChecked(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M19.778 2H4.222C3 2 2 3 2 4.222v15.556C2 21 3 22 4.222 22h15.556C21 22 22 21 22 19.778V4.222C22 3 21 2 19.778 2Z"
        fill="currentColor"
      />
      <path d="m10 17.42-5-5 1.41-1.41L10 14.59 17.59 7 19 8.42l-9 9Z" fill="#fff" />
    </BaseIcon>
  );
}
